import {
  authHeader,
  handleResponse,
  handleNoContentResponse,
} from "../_helpers";

const BASE_URL = process.env.REACT_APP_BASE_URL;

function getHMPLUSGlobalRelease(analyzer = "hmplus") {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };

  const endPoint = `/api/admin/v1/releases/analyzers/${analyzer}/global`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function addHMPLUSGlobalRelease(formData) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(formData),
  };

  const endPoint = `/api/admin/v1/releases/analyzers/hmplus/global`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleNoContentResponse)
    .then((data) => {
      return data;
    });
}

function editHMPLUSGlobalRelease(formData) {
  const requestOptions = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(formData),
  };

  const endPoint = `/api/admin/v1/releases/analyzers/hmplus/global`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleNoContentResponse)
    .then((data) => {
      return data;
    });
}

export const hmplusGlobalReleaseService = {
  getHMPLUSGlobalRelease,
  addHMPLUSGlobalRelease,
  editHMPLUSGlobalRelease,
};
